import { QueryClient, MutationCache } from '@tanstack/react-query'
import { isPlanFrozenError } from '@/utils/getErrorMessage'
import { queryKeys } from '@/lib/queryKeys'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: error => {
      // If another user froze the plan while we had it open, our next
      // rejected write should immediately flip this session's plan data
      // back to read-only rather than waiting for the next refetch.
      if (isPlanFrozenError(error)) {
        queryClient.invalidateQueries({ queryKey: queryKeys.planDetail.all })
        queryClient.invalidateQueries({
          queryKey: queryKeys.assortmentPlans.all,
        })
      }
    },
  }),
})
